import { makeStyles } from '@material-ui/core';

export const getApplyFiltersBtnStyles = (theme) => {
  return {
    color: 'white',
    borderRadius: '4px',
    fontSize: '16px',
    fontFamily: 'Roboto-Bold',
    textTransform: 'none',
    boxShadow: 'none',

    minHeight: '45px !important',
    height: '45px !important',

    '& .far': {
      marginRight: '0.5rem',
      position: 'relative',
      top: -1,
    },
  }
}

export const applyFiltersBtnText = {
  padding: '5px 8px',
  whiteSpace: 'nowrap',
}

export const styles = theme => ({
  filtersRoot: {
    padding: theme.spacing(3),
    // flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  applyFiltersBtn: {
    ...getApplyFiltersBtnStyles(theme),
  },
  applyFiltersBtnText: {
    ...applyFiltersBtnText
  },
  textField: {

    minHeight: '45px !important',
    height: '45px !important',
    maxHeight: '45px !important',

    '& input::placeholder': {
      color: 'rgba(0, 0, 0, 0.87)',
      opacity: 1,
    }
  },
  banksOption: {
    backgroundColor: 'white !important',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },
  }
});

export default makeStyles(styles);